package views.coletor

import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import ffSpan
import kotlinx.browser.document
import kotlinx.dom.clear
import lbTitulo
import model.Produtolote
import ffMsgAviso
import org.jetbrains.compose.web.attributes.onSubmit
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Form
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.HTMLDivElement
import utils.ff
import utils.ffJsonParse
import utils.ffVsRel
import views.componentes.*

class col009 {

    private val _t = "col009"
    private var lista: List<Produtolote>? = null

    fun show() {

        ffMsgAviso("")
        lbTitulo!!.innerText = "009 - Lista de produtos a vencer"

        val htmlDiv1 = document.getElementById("htmlDiv1") as HTMLDivElement
        htmlDiv1.clear()

        renderComposable(rootElementId = "htmlDiv1") {
            body()
        }

    }

    @Composable
    fun body() {


        //table-responsive-sm
        Form(action = "#", attrs = { classes("table-responsive-sm"); onSubmit { it.preventDefault() } })
        {
            val _table1Controler = remember { mutableStateOf(gsInput(_t)) }

            ffSpan("Lista de produtos a vencer em 30 dias correspondente ao faturamento total:" +
                    " ${_table1Controler.text()}")

            produtoLote(_table1Controler)

            if (!_table1Controler.json().equals("")) {
                Div({ classes("table-responsive-sm") }) {
                    //println0("zuza999")
                    ff.println0(_table1Controler.json().equals(""))
                    //val o = lista.unsafeCast<Array<dynamic>>()
                    //println0(o)

                    val lcon = ArrayList<table1>()
                    lcon.add(table1().add(60, "S", "N", "OO_PRODUTO       ", "Produto"))
                    lcon.add(table1().add(10, "D", "N", "PROLOT_DTVAL     ", "Validade"))
                    lcon.add(table1().add(10, "N", "N", "PROLOT_SALDO     ", "Qtd"))

                    table1().ffTable1(
                        lcon,
                        _table1Controler = _table1Controler,
                        _tbTipo = "Mesclado"
                    )

                }
                if (lista != null && _table1Controler.clickObj() >= 0) {
                    val onot = lista!!.get(_table1Controler.clickObj())
                    val sProduto = onot.PROLOT_PRODUTO.toString()
                    col001().show(sProduto)
                    _table1Controler.clickObjLimpar()
                }
            }

        }

    }

    fun produtoLote(_table1Controler: MutableState<String>) {

        Produtolote().getProdutoLote(30) { _lista ->
            lista = _lista
            _table1Controler.json(JSON.stringify(lista).ffJsonParse(true))
            ff.println0(lista)

            var dCustoTotal = 0.0
            for (o in _lista) {
                dCustoTotal = dCustoTotal + (o.EST_PRECOA00 * o.PROLOT_SALDO)
            }
            _table1Controler.text(dCustoTotal.toString().ffVsRel(2))
        }

    }

}